








import { Component, Prop, Vue } from 'vue-property-decorator';
import CaravanPlayer from 'caravan-player/src/CaravanPlayer.vue';
import Header from '@/views/Header.vue';

@Component({
  components: {
    CaravanPlayer,
    Header
  }
})
export default class App extends Vue {
  get themeColor(): string {
    return this.$store.state.color;
  }
}
